import { Box, ColorOptions, convertHexToRGBA, SpacerNew, Text, useWindowDimensions } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { whyUseJioPayData } from '../../static/staticData'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const WhyUseJioPay = () => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box ph={resPadding}>
      <Box alignSelf={'center'} w={isMob ? '100%' : '50%'}>
        <Text
          title={'Why should you use JioPay?'}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 32 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          color={'BLACK_21'}
          textAlign={'center'}
        />
        <SpacerNew size={32} />
        <Text
          title={'JioPay is a comprehensive app that lets you'}
          fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
          fontSize={isMob ? 14 : 24}
          lineHeight={isMob ? 20 : 40}
          letterSpacing={isMob ? 0 : -0.48}
          color={isMob ? 'PRIMARY_GREY' : 'BLACK_21'}
          textAlign={'center'}
        />
        <SpacerNew size={isMob ? 32 : 64} />
      </Box>
      <Box flexDirection={isMob ? 'column' : 'row'} gap={isMob ? 24 : 32}>
        {whyUseJioPayData?.map((item: any) => {
          return (
            <Box
              f={isMob ? undefined : 1}
              p={24}
              borderWidth={1}
              borderColor={'DISABLED_GREY'}
              borderRadius={16}
              align={isMob ? 'center' : undefined}>
              <Box
                w={isMob ? 48 : 72}
                h={isMob ? 48 : 72}
                borderRadius={36}
                bg={convertHexToRGBA(colors.JIO_PRIMARY_ALPHA, 10) as ColorOptions}
                align={'center'}
                justify={'center'}>
                <Icon id={item.icon} color={'#213BC8' as ColorOptions} size={isMob ? 21 : 32} />
              </Box>
              <SpacerNew size={isMob ? 16 : 32} />
              <Text
                title={item.title}
                fontFamily={'jiotype-medium'}
                fontSize={isMob ? 14 : 24}
                lineHeight={isMob ? 20 : 32}
                letterSpacing={isMob ? 0 : -0.48}
                color={'BLACK_21'}
                textAlign={isMob ? 'center' : undefined}
              />
            </Box>
          )
        })}
      </Box>
      <SpacerNew size={108} />
    </Box>
  )
}
